(function($) {
    $(window).on('load resize', function() {

        $('.js-image-height').each(function() {
            $this = $(this);
            imgHeight = $this.outerHeight() + 30;

            $this
                .closest('.js-inline-height')
                .css('height', imgHeight + 'px');
        });

    }).resize();
})(jQuery);
